import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, getErrorMessage } from "@/lib/api";

/**
 * Digio redirect return landing.
 * Digio sends the browser here when is_redirection_approach is enabled.
 */
export default function DigioKycCallback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Finishing Digio KYC…");
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const { data } = await api.post("/api/kyc/digio/sync", {});
        if (cancelled) return;
        setMessage(data?.autoApproved ? "KYC approved. Redirecting…" : "Status updated. Redirecting…");
        setTimeout(() => {
          if (!cancelled) navigate("/profile/kyc", { replace: true });
        }, 900);
      } catch (e) {
        if (cancelled) return;
        const msg = getErrorMessage(e);
        setErr(msg);
        setMessage("Could not sync Digio status.");
        setTimeout(() => {
          if (!cancelled) navigate("/profile/kyc", { replace: true });
        }, 2200);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-[60vh] grid place-items-center px-6">
      <div className="text-center max-w-md space-y-3">
        <Loader2 className="animate-spin mx-auto text-primary" size={28} />
        <p className="text-[15px] font-medium text-foreground">{message}</p>
        {err ? <p className="text-[13px] text-down">{err}</p> : null}
      </div>
    </div>
  );
}
